<template>
  <div class="wg-row component-area" id="file-drag-drop">
    <form 
        ref="fileform" 
        @dragover="$refs['fileform'].style['background-color'] = '#ccc';"
        @dragleave="$refs['fileform'].style['background-color'] = '#ddd';">
      <input type="file" name="file" id="file" multiple @change.prevent.stop="addFiles" />
      <div class="display-flex" style="align-items:center;">
        <span class="input-span">{{ $anm22.strLang(lang, 'Drop here or', 'Rilascia qui o') }}</span>
        <div class="com-anm22-app-horizontal-space" style="width:10px;"></div>
        <label class="input-label" for="file">
          {{ $anm22.strLang(lang, 'Choose files', 'Scegli file') }}
        </label>
      </div>
    </form>
    <div v-if="files.length > 0" class="wg-row com-anm22-app-scrolling-panel preview-list">
      <div v-for="(file, index) in files" :key="'im'+index" class="wg-row file-div" style="margin-bottom:5px;">
        <img class="preview" :ref="'preview'+parseInt( index )"/>
        <div class="com-anm22-app-text-s">{{ file.file.name }}</div>
        <div style="margin-left:auto;">
          <vue-circle
            v-show="!file.done"
            :ref="'progress'+index"
            :progress="0"
            :size="50"
            line-cap="round"
            :fill="{ color: '#007a96' }"
            empty-fill="rgba(0, 0, 0, .1)"
            :animation-start-value="0.0"
            :start-angle="0"
            insert-mode="append"
            :thickness="5"
            :show-percent="false"
            @vue-circle-end="file.done = true;">
              <p></p>
          </vue-circle>
          <img 
              v-show="file.done"
              class="com-anm22-app-img-fixed-height-l"
              style="display:none;"
              :src="$anm22.icons.getWorldIcon('tick')">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import VueCircle from 'vue2-circle-progress/src/index.vue';

export default {
  props: {
    uploadUrl: String,
    allowedExtensions: Array,
    addImageBeforeUpload: Function,
    onSuccess: Function
  },
  data() {
    return {
      dragAndDropCapable: false,
      files: [],
      currentFile: null,
      acceptedExtensions: []
    }
  },
  computed: {
    ...mapState({
      lang: state => state.lang
    })
  },
  methods: {
    /*
      Determines if the drag and drop functionality is in the
      window
    */
    determineDragAndDropCapable(){
      /*
        Create a test element to see if certain events
        are present that let us do drag and drop.
      */
      var div = document.createElement('div');

      /*
        Check to see if the `draggable` event is in the element
        or the `ondragstart` and `ondrop` events are in the element. If
        they are, then we have what we need for dragging and dropping files.

        We also check to see if the window has `FormData` and `FileReader` objects
        present so we can do our AJAX uploading
      */
      return ( ( 'draggable' in div )
        || ( 'ondragstart' in div && 'ondrop' in div ) )
        && 'FormData' in window
        && 'FileReader' in window;
    },
    /*
      This method is called on drop or change of input fields to register files
    */
    addFiles(e) {
      /*
        Capture the files from the drop event and add them to our local files
        array.
        If an array of accepted extensions is passed as a prop, we filter the files added to the
        component to match those extensions and discard the others.
      */
      const data = e.target.files || e.dataTransfer.files;
      for( let i = 0; i < data.length; i++ ){
        if(this.acceptedExtensions.length > 0) {
          let file = {
            file: data[i],
            uploadProgress: 0,
            done: false
          };
          //Check extension
          let valid = false;
          if(this.allowedExtensions.includes(this.$anm22.getFileExtension(file.file.name))) {
            this.files.push(file);
          } else {
            this.$anm22.eventBus.$emit("world-headbar-show-message", {
              text: this.$anm22.strLang(
                this.lang,
                "Invalid file extension: " + this.$anm22.getFileExtension(file.file.name),
                "Estensione file non valida: " + this.$anm22.getFileExtension(file.file.name)
              ),
              type: "alarm"
            });
            return;
          }
        } else {
          this.files.push( {
            file: data[i],
            uploadProgress: 0,
            done: false
          });
        }
      }
      //comincio l'upload e modifico le progress bar di conseguenza
      this.submitFiles();
      e.target.value = "";
    },
     showImagePreview(i,type,src) {
      if (type == 'img') {
        this.$refs["preview" + parseInt(i)][0].src = src;
      } else {
        this.$nextTick(function() {
            this.$refs["preview" + parseInt(i)][0].src = this.$anm22.icons.getWorldIcon(
              "fileDefault"
            );
          });
      }
    },
    /*
      Gets the image preview for the file.
    */
    showImagePreviews(){
      /*
        Iterate over all of the files and generate an image preview for each one.
      */
      for( let i = 0; i < this.files.length; i++ ){
        let file = this.files[i].file;
        /*
          Ensure the file is an image file
        */
        if ( /\.(jpe?g|png|gif|svg)$/i.test( file.name ) ) {
          /*
            Create a new FileReader object
          */
          let reader = new FileReader();

          /*
            Add an event listener for when the file has been loaded
            to update the src on the file preview.
          */
          reader.addEventListener("load", function(){
            this.$refs['preview'+parseInt( i )][0].src = reader.result;
          }.bind(this), false);

          /*
            Read the data for the file in through the reader. When it has
            been loaded, we listen to the event propagated and set the image
            src to what was loaded from the reader.
          */
          reader.readAsDataURL( file );
        } else {
          /*
            We do the next tick so the reference is bound and we can access it.
          */
          this.$nextTick(function(){
            this.$refs['preview'+parseInt( i )][0].src = this.$anm22.icons.getWorldIcon('fileDefault');
          });
        }
      }
    },
    /*
      Uploads images to server
    */
    submitFiles() {
      /*
        Iteate over any file sent over appending the files
        to the form data.
      */
      for( var i = 0; i < this.files.length; i++ ){
        let fileIndex = i;
        let localId = this.$anm22.genLocalId();
        let dataUrl;
        /*
        /*
          Initialize the form data - using FormData class
        */
        let formData = new FormData();
        let fileData = this.files[i];
        formData.append('file', fileData.file);
        if (/\.(jpe?g|png|gif|svg)$/i.test(fileData.file.name)) { // Controllo se si tratta di un'immagine
          /*
            Create a new FileReader object
          */
          let reader = new FileReader();

          /*
            Add an event listener for when the file has been loaded
            to update the src on the file preview.
          */
          reader.addEventListener(
            "load",
            function() {
              // Creo l'anteprima
              this.showImagePreview(fileIndex,'img',reader.result);

              // Se richiesto chiamo la funzione per salvare l'immagine offline prima di inviarla
              if(typeof this.addImageBeforeUpload !== 'undefined') {
                dataUrl = reader.result;
                this.files.splice(fileIndex, 1);
                /* Passo all'oggetto la src che ho impostato nell'anteprima */
                this.addImageBeforeUpload({
                  url: { src: dataUrl, file: fileData.file }, localId: localId
                });
              }

            }.bind(this),
            false
          );

          /*
            Read the data for the file in through the reader. When it has
            been loaded, we listen to the event propagated and set the image
            src to what was loaded from the reader.
          */
          reader.readAsDataURL(fileData.file);
      } else {
          this.showImagePreview(fileIndex,'file');

          this.$nextTick(function() {
            // Se richiesto chiamo la funzione per salvare l'immagine offline prima di inviarla
            if(typeof this.addImageBeforeUpload !== 'undefined') {
              dataUrl = this.$refs["preview" + parseInt(fileIndex)][0].src;
              this.files.splice(fileIndex, 1);
              /* Passo all'oggetto la src che ho impostato nell'anteprima */
              this.addImageBeforeUpload({
                url: { src: dataUrl, file: fileData.file }
              });
            }
          });
      }
        /*
          Make the request to the POST /file-drag-drop URL
        */
        this.$http
          .post(this.uploadUrl, formData, {
            headers: {
              "Content-Type": "multipart/form-data"
            },
            onUploadProgress: function( progressEvent ) {
              this.$refs['progress'+fileIndex][0].updateProgress(
                parseInt( Math.round( ( progressEvent.loaded * 100 ) / progressEvent.total ) )
              );
            }.bind(this)
          })
          .then(response => {
            this.files.splice(fileIndex, 1);
            response.data.localId = localId;
            response.data.localUrl = dataUrl;
            // Reset del componente -> caricamento delle foto in modo che vengano visualizzate come parte
            // integrante della scheda della spesa
            this.onSuccess(response.data);
          })
          .catch(error => {
            console.log(error);
            if(typeof this.addImageBeforeUpload == 'undefined') {
              const dataUrl = this.$refs["preview" + parseInt(fileIndex)][0].src;
              this.files.splice(fileIndex, 1);
              /* Passo all'oggetto la src che ho impostato nell'anteprima */
              this.onSuccess({
                url: { src: dataUrl, file: fileData.file }
              });
            }
          });
      }
    }
  },
  created() {
    if(this.allowedExtensions) {
      this.acceptedExtensions = this.allowedExtensions;
    }
  },
  mounted(){
    /* Determine if drag and drop functionality is capable in the browser */
    this.dragAndDropCapable = this.determineDragAndDropCapable();

    /* If drag and drop capable, then we continue to bind events to our elements. */
    if( this.dragAndDropCapable ){
      /*
        Listen to all of the drag events and bind an event listener to each
        for the fileform.
      */
      ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach( function( evt ) {
        /*
          For each event add an event listener that prevents the default action
          (opening the file in the browser) and stop the propagation of the event (so
          no other elements open the file in the browser)
        */
        this.$refs.fileform.addEventListener(evt, function(e){
          e.preventDefault();
          e.stopPropagation();
        }.bind(this), false);
      }.bind(this));

      /*
        Add an event listener for drop to the form
      */
      this.$refs.fileform.addEventListener('drop', function(e){
        this.addFiles(e);
      }.bind(this));
    }
  },
  components: {
    VueCircle
  }
};
</script>

<style lang="scss" scoped>
@import "../../libs/anm22_web_graphics/v1/scss/_variables.scss";

.component-area {
  width: 100%;
  max-width: 800px;
  // height: 100%;
  // background: #ddd;
  border-radius: 4px;
}
form{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 50px;
  background-color: #ddd;
  &:hover {
    background-color: #ccc;
  }
}
form input {
  width: 0.1px;
	height: 0.1px;
	opacity: 0;
	overflow: hidden;
	position: absolute;
	z-index: -1;
}
form .input-label {
  background-color:#007a96;
  padding:12px 26px;
  color:#fff;
  font-size:14px;
  border-radius:2px;
  cursor:pointer;
}
.preview-list {
  border-top: 1px solid #999;
  padding: 5px;
  min-height: 50px;
}
.file-div {
  border: 1px solid #999;
  padding: 5px;
  flex-wrap: nowrap;
  align-items: center;
  height: 50px;
}
.preview {
  height: 100%;
  max-width: 40%;
  margin-right: 5px;
}
.delete-icon {
  position: absolute;
  height: auto !important;
  top: 3px;
  left: 3px;
  cursor: pointer;
  z-index:10005;
}

/* In caso di mobile, mostro le immagini sotto la zona di drop */
// @media only screen and (max-width: $dimSM - 1) {
//   form{
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     width: 100%;
//     min-height: 50%;
//   }
//   .preview-list {
//     border-left: none;
//     border-top: 1px solid #999;
//     padding: 5px;
//     width: 100%;
//     height: 50%;
//   }
// }
</style>
